const UkLawyerType = {
  Barrister: 'Barrister',
  Solicitor: 'Solicitor',
} as const;

// Bar admissions that qualify a Lawyer for the UK lawyer-type concept. Matched
// by name (not country code) — Scotland / Registered Foreign Lawyer also map to
// the UK country code but do not qualify.
const QualifyingUkAdmissionNames = [
  'UK - England & Wales',
  'UK - Northern Ireland',
] as const;

export const CandidateSettingsConst = {
  UkLawyerType,
  QualifyingUkAdmissionNames,
} as const;

export type UkLawyerType =
  (typeof CandidateSettingsConst.UkLawyerType)[keyof typeof CandidateSettingsConst.UkLawyerType];
